import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Lot } from "../state/types"

export const useLotActions = () => {
    const saveActions = useSaveActions()

    const saveLot = (lot: Lot) => {
        const { save } = saveActions()
        return save(TableName.LOTS, lot) as Promise<Lot>
    }

    const removeLots = (ids: string[]) => {
        const { removeMultiple } = saveActions()
        return removeMultiple(TableName.LOTS, ids)
    }

    return {
        saveLot,
        removeLots
    }
}
